import lobby from './lobby';
import i18n from '../../localization';


const state = {
    loadingCount: 0,
    errorMessages: [],
    htmlContent: '',
}

const getters = {
    LoadingCount: state => state.loadingCount,
    anyErrors: state => state.errorMessages.length !== 0,
    errorsCount: state => state.errorMessages.length,
    errorMessages: state => state.errorMessages,
    htmlContent: state => state.htmlContent
}

const mutations = {
    ["UPDATE_LANGUAGE"](state, value) {
        i18n.locale = value;
    },
    ["TURN_ON_SPINNER"](state) {
        state.loadingCount = state.loadingCount + 1;
    },
    ["TURN_OFF_SPINNER"](state) {
        if (state.loadingCount != 0) {
            state.loadingCount = state.loadingCount - 1;
        }
    },
    ADD_ERROR_MESSAGES(state, errorMessage) {
        state.errorMessages.push(errorMessage);
    },
    ADD_ERROR_HTML(state, errorMessage) {
        state.htmlContent = errorMessage;
    },
    CLEAR_ERROR_MESSAGES(state) {
        state.errorMessages = [];
        state.htmlContent = '';
    },
}

const actions = {
    //switchLanguage({ commit, state }) {
    //    let lang = i18n.locale === 'en' ? 'sp' : 'en';
    //    commit("UPDATE_LANGUAGE", lang);
    //},
    updateLanguage({ commit, state }, lang) {
        commit("UPDATE_LANGUAGE", lang);
    },
    updateLanguageFromQuery({ commit, state }, lang) {
        const languages = ['en', 'sp'];
        if (languages.includes(lang)) {
            commit("UPDATE_LANGUAGE", lang);
        }
    },
    turnOffSpinner({ commit, state }) {
        commit("TURN_OFF_SPINNER");
    },
    turnOnSpinner({ commit, sate }) {
        commit("TURN_ON_SPINNER");
    },
    clearErrorMessages({ commit, state }) {
        commit("CLEAR_ERROR_MESSAGES");
        commit("TURN_OFF_SPINNER");
    },
    addErrorMessages({ commit, state }, error) {
        commit("ADD_ERROR_MESSAGES", error);
        commit("TURN_OFF_SPINNER");
    },
    addErrorHTML({ commit, state }, error) {
        commit("ADD_ERROR_HTML", error);
        commit("TURN_OFF_SPINNER");
    },
    handleResponse({ commit, state }, response) {
        if (response.responseCode === "200" || response.statusReason == "Success" || response.status == "OK" || response.success) {
            commit("TURN_OFF_SPINNER");
            if (response.result) {
                return response.result;
            }
            if (response.data) {
                return response.data.result;
            }
            if (response.error != null) {
                lobby.mutations.SET_QUICKPAY_CUSTOMER(lobby.state, { confirmed: false });
                let message = response.error.message;
                commit("ADD_ERROR_MESSAGES", message);
                commit("TURN_OFF_SPINNER");
            }
            return response;
        }
        else if (response.error == null || response.responseMessage == undefined) {
            commit("TURN_OFF_SPINNER");
            return response;
        }
        else {
            let message = response.responseMessage ?? response.status;
            commit("ADD_ERROR_MESSAGES", message);
            commit("TURN_OFF_SPINNER");
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}